import { formatNo } from './truckCatalog';

const parseNo = s => Number(String(s ?? '').trim().replace(',', '.'));
const round1 = n => Math.round(n * 10) / 10;

// Tonnmeter for et løft (tonn × meter). null når verdiene ikke er over 0.
export function liftMoment(tons, meters) {
  const t = parseNo(tons), m = parseNo(meters);
  return Number.isFinite(t) && Number.isFinite(m) && t > 0 && m > 0 ? round1(t * m) : null;
}

// Advarsel (blokkerer ikke) når løftet er over kranens kapasitet i tonnmeter.
export function craneLiftWarning({ tons, meters } = {}, craneTm) {
  const tm = liftMoment(tons, meters);
  if (tm == null || !(craneTm > 0) || tm <= craneTm) return null;
  return `Kranen rekker kanskje ikke: ${formatNo(parseNo(tons))} t på ${formatNo(parseNo(meters))} m er ${formatNo(tm)} tm, bilen har ca. ${formatNo(craneTm)} tm.`;
}

// Det som lagres på ordren: tall når begge er over 0, ellers null.
export function normalizeCraneLift(raw) {
  const t = round1(parseNo(raw?.tons)), m = round1(parseNo(raw?.meters));
  return Number.isFinite(t) && Number.isFinite(m) && t > 0 && m > 0 && t <= 1000 && m <= 1000 ? { tons: t, meters: m } : null;
}
